import React from 'react';
import styled from 'styled-components';
import { Pagination } from 'antd';

const StyledPagination = styled(Pagination)`
  .ant-pagination-simple-pager input {
    width: 40px;
    border-radius: 6px;
  }
`;

type TablePaginatorProps = {
  total?: number;
  pagination: { current?: number; pageSize?: number };
  style?: { float: string };
} & React.ComponentProps<typeof StyledPagination>;

const TablePaginator: React.FC<TablePaginatorProps> = ({
  pagination,
  onChange,
  ...props
}) => (
  <StyledPagination
    simple
    size="small"
    defaultCurrent={1}
    current={pagination.current}
    pageSize={pagination.pageSize}
    onChange={onChange}
    {...props}
  />
);

export default TablePaginator;
